import script from "./RequestSnackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestSnackbar.vue?vue&type=script&setup=true&lang=js"

import "./RequestSnackbar.vue?vue&type=style&index=0&id=317bb721&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317bb721"]])

export default __exports__